import React from "react";
import { Alert, Type } from "mesh-component-library";
import {
  CANADA_COUNTRY_CODE,
  en_CA,
  GALLON,
  LITER,
  USA_COUNTRY_CODE,
  SURCHARGE
} from "../../app-consts/appConstants";
import { determineLocale, useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";

export const FuelAlert = ({ fuelServiceCoverages }) => {
  const getTranslatedText = useLocale();
  const locale = determineLocale();
  let status = "";
  let quantity = 0;
  let unit = "";
  let coverage: any = {};
  if (locale === en_CA) {
    coverage = fuelServiceCoverages?.find(
      (coverage) => coverage?.country === CANADA_COUNTRY_CODE
    );
    status = coverage?.status;
    quantity = coverage?.quantity;
    unit = LITER;
  } else {
    coverage = fuelServiceCoverages?.find(
      (coverage) => coverage?.country === USA_COUNTRY_CODE
    );
    status = coverage?.status;
    quantity = coverage?.quantity;
    unit = GALLON;
  }

  return (
    status !== SURCHARGE &&
      <Alert
        variant="information"
        size="md"
        title={
          <Type align="left">
            {`You'll receive ${quantity ? quantity : 2} ${unit}${
              quantity && quantity < 2 ? "" : "s"
            } of fuel.`}
          </Type>
        }
        children={
          <Type align="left">
            {status?.toLowerCase() === "covered"
                ? getTranslatedText(TRANSLATION_CONSTANTS.VAS_FUEL_COVERED)
                : getTranslatedText(TRANSLATION_CONSTANTS.VAS_FUEL_NOT_COVERED)}
          </Type>
        }
      ></Alert>
  );
};
